import { createAction, props } from '@ngrx/store';

const GET_ALL_LOGS = '[Completion-logs] Get All Logs';
const SET_LOGS = '[Completion-logs] Set Logs';
const DELETE_LOGS = '[Completion-logs] Delete Logs';
const CLEAR_LOGS = '[Completion-logs] Clear Logs';

const getAllLogs = createAction(GET_ALL_LOGS, props<{ apiConstants: any; urlPathVariables: any }>());
const setLogs = createAction(SET_LOGS, props<{ data: any }>());
const deleteLogs = createAction(DELETE_LOGS, props<{ apiConstants: any; urlPathVariables: { componentId: string } }>());
const clearLogs = createAction(CLEAR_LOGS);

const LogsActions = {
  getAllLogs,
  setLogs,
  deleteLogs,
  clearLogs
};

export default LogsActions;
